
import React, { useState, useEffect } from "react";
import ConnectAPI from "../../services/api";
import { authenticationService } from "../../services/context/AuthService";
import Swal from "sweetalert2";
import { Row, Col, Container } from 'react-bootstrap';
import moment from "moment";
import {Modal  , Button ,IconCheckmark, Stepper, TextArea, Select,TextBox, List ,ListItem, IconX, Toggle} from "@veneer/core";

import { useTranslation } from "react-i18next";


const EmailShow = ({ onShowModal, setOnShowModal, onCloseSCDetailsModal,details}) => {
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    let subject="";
    let body="";
    let audiencelevel="";
    let audience="";
    if (details!=null){
        let email=details.split(";");
        
        email.forEach(element => {
        let elements=element.split("=");
        switch(elements[0].trim()){
            case "audiencelevel":
                audience=elements[1];
                break;
            case "audience":
                audiencelevel=elements[1];
                break;
            case "subject":
                subject=elements[1];
                break;
            case "body":
                body=elements[1];
                break;
        }
    });

    }
   
    return (
        <>
        <Modal
            id="regular-modal"
            show={onShowModal}
            onClose={() => { onCloseSCDetailsModal(); }}
            css={{
                '.vn-modal--content': {
                    width: "800px !important",
                    height:"750px !important",
                },
            }}
            title="Emails"
        >
           
            <Row>
                <Col xs="8" md="8"  >
                    <div><b>{t("subject")}</b>:{subject}</div>

                    <div>
                        {
                            body.replaceAll("<p>","").replaceAll("</p>","\r\n").split('\r\n').map(en=>{return(<><p>{en}</p></>)})
                            
                        }
                    </div>
                </Col>
                <Col xs="4" md="4">
                    {(audience=="role")?(
                            <>
                                <div><b>{t("audience")}:</b> Role</div>
                                {audiencelevel.split(",").map(element => {
                                  return (
                                    <>
                                        <p><b>{element}</b></p>
                                    </>

                                );
                                })}
                            </>
                        ):(
                            (audience=="email")?(
                                <>
                                    <div><b>{t("audience")}:</b> Emails</div>
                                    
                                    <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                                    {audiencelevel.split(",").map(x=>{
                                        return (
                                            <>
                                                <ListItem 
                                                        centerArea={<div>{x}</div>}
                                                />
                                            </>
                                        );
                                    })}
                                    {audiencelevel.split(",").forEach(element => {
                                        return (
                                        <>
                                            <ListItem 
                                                    centerArea={<div>{element}</div>}
                                            />
                                        </>

                                    );
                                    })}
                                </List>
                                </>
                                
                            ):(
                                (audience=="subregion")?(
                                    <>
                                        <div><b>{t("audience")}:</b> Subregions</div>
                                        {audiencelevel.split(",").map(element => {
                                        return (
                                            <>
                                                <p><b>{element}</b></p>
                                            </>

                                        );
                                        })}
                                    </>
                                    
                                ):((audience=="enduser")?(
                                    <>
                                        <div><b>{t("audience")}:</b> End Users</div>
                                       
                                    </>
                                    ):((audience=="channel")?(
                                        <>
                                            <div><b>{t("audience")}:</b> Channels</div>
                                            {audiencelevel.split(",").map(element => {
                                            return (
                                                <>
                                                    <p><b>{element}</b></p>
                                                </>

                                            );
                                            })}
                                        </>
                                        ):((audience=="role & subregion")?(
                                            <>
                                                <div><b>{t("audience")}:</b> Roles y Subregion</div>
                                                {audiencelevel.split(",").map(element => {
                                                return (
                                                    <>
                                                        <p><b>{element}</b></p>
                                                    </>

                                                );
                                                })}
                                               
                                            </>
                                        ):(""))))
                            )
                        )}
                </Col>
            </Row>

        
        </Modal>
        </>
    );
}
export default EmailShow;